import { type Lootbox, LootboxStage } from '@/api/common';
import { isToday } from '@/modules/promotions/helpers/fortuneWheel';
import { DAILY_LIMIT } from '@/modules/promotions/helpers/scratchGame';

export const getFirstIssuedLootbox = (lootboxes: Lootbox[]) =>
  lootboxes.find((lootbox) => lootbox.stage === LootboxStage.Issued);

export const checkIsReachedDailyLootboxesLimit = (lootboxes: Lootbox[]) => {
  const currentLootboxes = lootboxes.filter((lootbox) =>
    isToday(lootbox.createdAt)
  );

  const activatedLootboxes = currentLootboxes.filter(
    (lootbox) => lootbox.stage === LootboxStage.Activated
  ).length;

  const dailyActivatedLootboxes = DAILY_LIMIT - activatedLootboxes || 0;

  return {
    isReachedDailyLimit: activatedLootboxes >= DAILY_LIMIT,
    dailyActivatedLootboxes,
  };
};
